"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaqItem = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

require("./template-1-faq-item.css");

function FaqItem(_ref) {
  var title = _ref.title,
      content = _ref.content,
      active = _ref.active,
      handleState = _ref.handleState,
      index = _ref.index;
  return react_1.default.createElement("div", {
    className: "faq-item w-full overflow-hidden border-t"
  }, react_1.default.createElement("div", {
    className: "faq-item-heading",
    onClick: function onClick() {
      return handleState(index, !active);
    }
  }, react_1.default.createElement("label", {
    className: "block p-5 leading-normal cursor-pointer faq-item-title font-semibold"
  }, title), react_1.default.createElement("div", {
    className: "toogle-active"
  }, react_1.default.createElement("span", {
    className: "faq-item-heading-icon ".concat(!active ? 'faq-icon-display' : 'faq-icon-hidden', " ")
  }))), react_1.default.createElement("div", {
    className: "faq-tab-content ".concat(active ? 'tab-content-display' : 'tab-content-hidden', " leading-normal")
  }, react_1.default.createElement("p", {
    className: "pt-1 pb-3 pl-5 pr-5"
  }, content)));
}

exports.FaqItem = FaqItem;
FaqItem.propTypes = {
  title: prop_types_1.default.string,
  content: prop_types_1.default.string,
  active: prop_types_1.default.bool
};
FaqItem.defaultProps = {
  title: '',
  content: '',
  active: false
};